// directives/animate.js
export default {
  mounted(el: HTMLDivElement, binding: any) {
    const opts = {
      direction: binding.value?.direction || 'up',
      distance: binding.value?.distance || 50,
      duration: binding.value?.duration || 0.8,
      delay: binding.value?.delay || 0,
      opacity: binding.value?.opacity !== false,
    }

    // 初始状态
    let transform = ''
    switch (opts.direction) {
      case 'up':
        transform = `translateY(${opts.distance}px)`
        break
      case 'down':
        transform = `translateY(-${opts.distance}px)`
        break
      case 'left':
        transform = `translateX(${opts.distance}px)`
        break
      case 'right':
        transform = `translateX(-${opts.distance}px)`
        break
    }

    el.style.opacity = opts.opacity ? '0' : '1'
    el.style.transform = transform
    el.style.transition = `all ${opts.duration}s ease ${opts.delay}s`

    // 使用 IntersectionObserver 监听进入视口
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.style.opacity = '1'
          el.style.transform = 'translate(0,0)'
          observer.unobserve(el) // 动画只触发一次
        }
      })
    })

    observer.observe(el)
  },
}
